<template>
    <div>
        <StructuredData />
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--150" no-body>
                    <div class="px-4 py-5">
                        <div class="text-center mb-5">
                            <h1 class="display-3">E-Commerce Entwicklung</h1>
                            <p class="lead">
                                Professionelle Online-Shop Lösungen für nachhaltigen Erfolg im DACH-Raum
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-lg-8 mx-auto">
                                <h2>Ihr erfolgreicher Online-Shop</h2>
                                <p>
                                    E-Commerce ist mehr als nur ein Online-Shop. Es ist Ihr 24/7 Verkaufskanal, 
                                    der perfekt auf Ihre Kunden und Produkte abgestimmt sein muss. Wir entwickeln 
                                    skalierbare E-Commerce-Lösungen, die Ihre Verkäufe maximieren.
                                </p>

                                <h3 class="mt-5">Unsere E-Commerce Leistungen</h3>
                                
                                <div class="row mt-4">
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-warning">
                                                    <icon name="fa fa-shopping-cart" class="mr-2"></icon>
                                                    Online-Shop Entwicklung
                                                </h5>
                                                <p>
                                                    Von der Planung bis zum Launch. Wir entwickeln Ihren Online-Shop 
                                                    mit WooCommerce, Shopify oder individuellen Lösungen.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-success">
                                                    <icon name="ni ni-chart-bar-32" class="mr-2"></icon>
                                                    Conversion-Optimierung
                                                </h5>
                                                <p>
                                                    Mehr Verkäufe aus bestehendem Traffic. Wir optimieren Ihren 
                                                    Shop für maximale Conversion-Rates.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-primary">
                                                    <icon name="ni ni-settings-gear-65" class="mr-2"></icon>
                                                    Schnittstellen & Integration
                                                </h5>
                                                <p>
                                                    Anbindung an Warenwirtschaft, ERP, CRM, Payment-Provider 
                                                    und Marketing-Tools.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-info">
                                                    <icon name="ni ni-mobile-button" class="mr-2"></icon>
                                                    Mobile Commerce
                                                </h5>
                                                <p>
                                                    Optimiert für Mobile Shopping. Über 60% der Käufe erfolgen 
                                                    heute über mobile Geräte.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                </div>

                                <h3 class="mt-5">E-Commerce Technologien</h3>
                                <div class="mt-3">
                                    <badge type="warning" rounded class="mr-2 mb-2">WooCommerce</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Shopify</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Stripe</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">PayPal</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Klarna</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Google Analytics</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Facebook Pixel</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Google Ads</badge>
                                </div>

                                <h3 class="mt-5">Erfolgreiche E-Commerce Projekte</h3>
                                <ul class="list-unstyled mt-3">
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Über 50 erfolgreiche Online-Shops entwickelt
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Expertise in Conversion-Optimierung
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Skalierbare Architekturen für Wachstum
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        DSGVO-konforme Implementierung
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Performance & Security First
                                    </li>
                                </ul>

                                <div class="text-center mt-5">
                                    <base-button
                                        tag="a"
                                        href="/#kontakt"
                                        type="warning"
                                        size="lg"
                                        icon="fa fa-envelope"
                                        @click.prevent="$router.push('/#kontakt')"
                                    >
                                        Jetzt E-Commerce Projekt anfragen
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import StructuredData from '../components/StructuredData.vue'

export default {
    name: 'ecommerce',
    components: {
        StructuredData
    },
    head: {
        title: {
            inner: 'E-Commerce Entwicklung DACH',
            separator: '|',
            complement: 'Web Services and More'
        },
        meta: [
            {
                name: 'description',
                content: 'E-Commerce Agentur DACH ✓ Online-Shop Entwicklung ✓ WooCommerce & Shopify ✓ Conversion-Optimierung ✓ Payment-Integration ✓ 15+ Jahre Erfahrung ✓ Jetzt anfragen!',
                id: 'desc'
            },
            {
                name: 'keywords',
                content: 'E-Commerce Entwicklung, Online-Shop Entwicklung, WooCommerce Shop, Shopify Entwicklung, Webshop erstellen, Conversion-Optimierung, E-Commerce DACH, Online-Shop Deutschland'
            },
            {
                property: 'og:title',
                content: 'E-Commerce Entwicklung DACH | Web Services and More'
            },
            {
                property: 'og:description',
                content: 'E-Commerce Agentur im DACH-Raum. Online-Shop Entwicklung mit WooCommerce & Shopify, Conversion-Optimierung, Payment-Integration. 15+ Jahre Erfahrung.'
            },
            {
                property: 'og:type',
                content: 'website'
            },
            {
                property: 'og:url',
                content: 'https://www.wsam.biz/ecommerce'
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:title',
                content: 'E-Commerce Entwicklung DACH | Web Services and More'
            },
            {
                name: 'twitter:description',
                content: 'E-Commerce Agentur im DACH-Raum. Online-Shop Entwicklung mit WooCommerce & Shopify, Conversion-Optimierung.'
            }
        ]
    }
}
</script>
